import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  setPartnerAccountList,
  setPartnerDetails,
  setResponse,
  setTotalCount,
} from '../../actions/backoffice/partnerActions';
import {
  CREATE_PARTNER,
  PARTNER_ACCOUNT_DETAIL,
  PARTNER_ACCOUNT_LIST_REQUEST,
  PARTNER_EMAIL_CHECK,
  REMOVE_PARTNER,
} from '../../constants/backoffice/partnerConstants';
import BaseResponse from '../../models/src/model/BaseResponse';
import PartnerControllerDtoPartnerAccountListResponse
  from '../../models/src/model/PartnerControllerDtoPartnerAccountListResponse';
import PartnerControllerDtoPartnerAccountCheckResponse
  from '../../models/src/model/PartnerControllerDtoPartnerAccountCheckResponse';
import PartnerControllerDtoPartnerAccountRemoveResponse
  from '../../models/src/model/PartnerControllerDtoPartnerAccountRemoveResponse';
import PartnerControllerDtoPartnerAccountDetailResponse
  from '../../models/src/model/PartnerControllerDtoPartnerAccountDetailResponse';
import PerplayPartnerApi from "../../models/src/api/PerplayPartnerApi";
import PartnerControllerDtoPartnerAccountListRequest
  from "../../models/src/model/PartnerControllerDtoPartnerAccountListRequest";
import PartnerControllerDtoPartnerAccountRemoveRequest
  from "../../models/src/model/PartnerControllerDtoPartnerAccountRemoveRequest";
import PartnerControllerDtoPartnerAccountDetailRequest
  from "../../models/src/model/PartnerControllerDtoPartnerAccountDetailRequest";
import PartnerControllerDtoPartnerAccountCreateRequest
  from "../../models/src/model/PartnerControllerDtoPartnerAccountCreateRequest";
import PartnerControllerDtoPartnerAccountCheckRequest
  from "../../models/src/model/PartnerControllerDtoPartnerAccountCheckRequest";

const api = new PerplayPartnerApi(config.API_CLIENT);

function* partnerAccountListRequestSaga(payload) {
  try {
    const result = yield api.apiPerplayPartnerPartnerAccountListPost(
      {
        partnerControllerDtoPartnerAccountListRequest: new PartnerControllerDtoPartnerAccountListRequest(
          payload.page,
          payload.pageLength,
        ),
      },
      () => {},
    );
    const data = api.apiClient.deserialize(result, PartnerControllerDtoPartnerAccountListResponse);
    console.log('data: ', data);
    yield put(setPartnerAccountList(data.list));
    yield put(setTotalCount(data.totalCount));
  } catch (e) {
    console.log(e);
  }
}

function* partnerAccountCheckSaga(payload) {
  try {
    console.log('중복 확인');
    const result = yield api.apiPerplayPartnerPartnerAccountCheckPost(
      { partnerControllerDtoPartnerAccountCheckRequest: new PartnerControllerDtoPartnerAccountCheckRequest(payload.email) },
      () => {},
    );
    console.log('result: ', result);
    const data = api.apiClient.deserialize(result, PartnerControllerDtoPartnerAccountCheckResponse);
    console.log('data: ', data);

    yield put(setResponse(data));
  } catch (e) {
    console.log(e);
  }
}

function* createPartnerSaga(payload) {
  try {
    console.log('생성');
    const requestData = new PartnerControllerDtoPartnerAccountCreateRequest();
    requestData.email = payload.email;
    console.log(requestData);
    const result = yield api.apiPerplayPartnerPartnerAccountCreatePost(
      { partnerControllerDtoPartnerAccountCreateRequest: requestData },
      () => {},
    );
    console.log('result: ', result);
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('data: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* removePartnerSaga(payload) {
  try {
    console.log('삭제');
    const requestData = new PartnerControllerDtoPartnerAccountRemoveRequest();
    requestData.accountNo = payload.accountNo;
    console.log('requestData: ', requestData);
    const result = yield api.apiPerplayPartnerPartnerAccountRemovePost(
      { partnerControllerDtoPartnerAccountRemoveRequest: requestData },
      () => {},
    );
    const data = api.apiClient.deserialize(result, PartnerControllerDtoPartnerAccountRemoveResponse);
    console.log('data: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* partnerDetailsSaga(payload) {
  try {
    console.log('디테일');
    const result = yield api.apiPerplayPartnerPartnerAccountDetailPost(
      {
        partnerControllerDtoPartnerAccountDetailRequest: new PartnerControllerDtoPartnerAccountDetailRequest(payload.accountNo),
      },
      () => {},
    );
    const data = api.apiClient.deserialize(result, PartnerControllerDtoPartnerAccountDetailResponse);
    console.log('data: ', data);

    yield put(setPartnerDetails(data.appList));
  } catch (e) {
    console.log(e);
  }
}

function* partnerRootSaga() {
  yield all([
    takeEvery(PARTNER_ACCOUNT_LIST_REQUEST, partnerAccountListRequestSaga),
    takeEvery(PARTNER_EMAIL_CHECK, partnerAccountCheckSaga),
    takeEvery(CREATE_PARTNER, createPartnerSaga),
    takeEvery(REMOVE_PARTNER, removePartnerSaga),
    takeEvery(PARTNER_ACCOUNT_DETAIL, partnerDetailsSaga),
  ]);
}

const partnerSagas = [fork(partnerRootSaga)];

export default partnerSagas;
